import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthContext.js';
import ProtectedRoute from './ProtectedRoute.js';
import RoleRoute from './RoleRoute.js';
import AdminLayout from './AdminLayout.js';
import LoginPage from './LoginPage.js';
import RoutesListPage from './RoutesListPage.js';
import RouteDetailPage from './RouteDetailPage.js';
import CsvImportPage from './CsvImportPage.js';
import GuidePage from './GuidePage.js';
import ProfilePage from './ProfilePage.js';
import TeamPage from './TeamPage.js';
import BookedWorkPage from './BookedWorkPage.js';
import PayrollPage from './PayrollPage.js';

const AdminRedirect = () => {
  const { pathname } = useLocation();
  const newPath = pathname.replace(/^\/admin/, '/portal');
  return <Navigate to={newPath} replace />;
};

const AdminApp = () => {
  return (
    <AuthProvider>
      <Routes>
        {/* Portal routes */}
        <Route path="/portal/login" element={<LoginPage />} />
        <Route
          path="/portal"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="routes" element={<RoutesListPage />} />
          <Route path="routes/:routeId" element={<RouteDetailPage />} />
          <Route path="booked" element={<BookedWorkPage />} />
          <Route path="import" element={<CsvImportPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route
            path="team"
            element={
              <RoleRoute>
                <TeamPage />
              </RoleRoute>
            }
          />
          <Route path="payroll" element={<PayrollPage />} />
          <Route path="guide" element={<GuidePage />} />
          <Route index element={<Navigate to="routes" replace />} />
        </Route>

        {/* Redirect old /admin/* paths to /portal/* */}
        <Route path="/admin/*" element={<AdminRedirect />} />
      </Routes>
    </AuthProvider>
  );
};

export default AdminApp;
